import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import userAPI from "../api/userAPI";

export const fetchMultipleEntryPasses = createAsyncThunk(
  "multipleEntryPass/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      return await userAPI.getAllMultipleEntryPass(params);
    } catch (err) {
      return rejectWithValue(err.mess);
    }
  },
);

export const checkCanPurchasePass = createAsyncThunk(
  "multipleEntryPass/checkCanPurchase",
  async (params, { rejectWithValue }) => {
    try {
      const result = await userAPI.canPassPurchasePossible(params);
      return result;
    } catch (err) {
      return rejectWithValue(err.mess);
    }
  },
);

export const multipleEntryPassSlice = createSlice({
  name: "multipleEntryPassSlice",
  initialState: {
    passes: [],
    canPurchaseNewPass: null,
    purchasePassReasonFlag: null,
  },
  reducers: {
    addNewMultipleEntryPass: (state, action) => {
      if (!state.passes) {
        state.passes = [];
      }
      state.passes.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMultipleEntryPasses.fulfilled, (state, action) => {
        state.passes = action.payload;
      })
      .addCase(fetchMultipleEntryPasses.rejected, (state, action) => {
        console.error("Failed to fetch multiple entry passes:", action.payload);
      })
      .addCase(checkCanPurchasePass.fulfilled, (state, action) => {
        state.canPurchaseNewPass = action.payload.IsPassPurchasePossible;
        state.purchasePassReasonFlag = action.payload.IsRegularOrderFound;
      })
      .addCase(checkCanPurchasePass.rejected, (state, action) => {
        console.error("Failed to check can purchase pass:", action.payload);
      });
  },
});

export const { addNewMultipleEntryPass } = multipleEntryPassSlice.actions;

export const selectMultipleEntryPasses = (state) => state.multipleEntryPassSlice.passes;
export const selectCanPurchaseNewPass = (state) => state.multipleEntryPassSlice.canPurchaseNewPass;
export const selectPurchasePassReasonFlag = (state) => state.multipleEntryPassSlice.purchasePassReasonFlag;

export const activeMultipleEntryPassesSelector = createSelector([selectMultipleEntryPasses], (passes) =>
  (passes || []).filter((pass) => pass.IsAvailable),
);

export const activeMultipleEntryPassesDetailsSelector = createSelector([selectMultipleEntryPasses], (passes) =>
  (passes || []).find((pass) => pass.IsAvailable),
);

export const inactiveMultipleEntryPassesSelector = createSelector([selectMultipleEntryPasses], (passes) =>
  (passes || []).filter((pass) => !pass.IsAvailable),
);

export const hasActiveMultipleEntryPassSelector = createSelector([selectMultipleEntryPasses], (passes) =>
  (passes || []).some((pass) => pass.IsAvailable),
);

export const canBuyNewMultipleEntryPassSelector = selectCanPurchaseNewPass;

export const purchasePassReasonFlagSelector = selectPurchasePassReasonFlag;

export default multipleEntryPassSlice.reducer;
